import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const KEY = "bragame_age_confirmed_v1";

// Routes where the AgeGate must NOT render — pages that refuse service or
// are non-consumable "system" pages. `/blocked` is the primary case: a user
// hitting a geo-refusal has no reason to be asked to age-verify first, and
// the AgeGate's near-opaque backdrop (rgba(6,4,3,0.92) + 8px blur) otherwise
// paints the block message into invisibility → "black screen" reports.
const SKIP_PATHS = new Set(["/blocked"]);

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (SKIP_PATHS.has(pathname)) { setOpen(false); return; }
    const confirmed = localStorage.getItem(KEY) === "true";
    if (!confirmed) setOpen(true);
  }, [pathname]);

  if (!open || SKIP_PATHS.has(pathname)) return null;

  const accept = () => {
    localStorage.setItem(KEY, "true");
    setOpen(false);
  };
  const exit = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      style={{ background: "rgba(6, 4, 3, 0.92)", backdropFilter: "blur(8px)" }}
      data-testid="age-gate-modal"
      role="dialog"
      aria-modal="true"
    >
      <div className="max-w-lg w-full border border-[color:var(--line)] p-8 rounded-sm"
           style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.02), transparent) var(--card)" }}>
        <div className="text-[10px] tracking-[0.35em] uppercase text-[color:var(--gold)] mb-4">
          18+ Age Verification
        </div>
        <h2 className="font-display italic text-4xl leading-tight text-[color:var(--ink)] mb-4">
          You must be 18 or older<br/>to enter this site.
        </h2>
        <p className="text-sm text-[color:var(--muted)] leading-relaxed mb-6">
          Bra Game contains adult-themed content and simulated wagering.
          Gambling can be addictive — <span className="text-[color:var(--ink)]">play responsibly</span>.
          By continuing, you confirm you are of legal age in your jurisdiction and accept our terms.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <button
            onClick={exit}
            className="py-3 border border-[color:var(--line)] text-[color:var(--muted)] uppercase tracking-widest text-xs hover:text-[color:var(--ink)] hover:border-[color:var(--muted)] transition"
            data-testid="age-gate-exit-btn"
          >
            Exit
          </button>
          <button
            onClick={accept}
            className="py-3 uppercase tracking-widest text-xs font-semibold hover:brightness-110 transition"
            style={{ background: "linear-gradient(180deg, #FFC947 0%, #FF9A2E 100%)", color: "#1a1512" }}
            data-testid="age-gate-accept-btn"
          >
            I am 18+ · Enter
          </button>
        </div>
      </div>
    </div>
  );
}
